<script lang="ts">
    
    import { onMount } from 'svelte';
    import { Router, Route } from 'svelte-navigator';
    import { Styles } from "sveltestrap";
    import EndGame from './Views/EndGame.svelte';
    import Game from './Views/Game.svelte';
    import Home from './Views/Home.svelte';
    import PlayerConfig from './Views/PlayerConfig.svelte';

    onMount(updateCssVars);

    function updateCssVars(): void {
        window.document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    }

</script>

<svelte:window on:resize={updateCssVars} />
	
<Styles />

<Router primary={false}>
    <Route path="/" component={Home} />
    <Route path="/inicio" component={PlayerConfig} />
    <Route path="/game" component={Game} />
    <Route path="/fin-game" component={EndGame} />
</Router>
